// extracted by mini-css-extract-plugin
export var container = "bokehCardsBlock-module--container--Ov1De";
export var gradient = "bokehCardsBlock-module--gradient--s6RM8";
export var inner = "bokehCardsBlock-module--inner--TJRX0";
export var flexContainer = "bokehCardsBlock-module--flexContainer--yUGtV";
export var flexItem = "bokehCardsBlock-module--flexItem--BTxR9";